export const breadcrumbs = [
  {
    text: "Главная",
    disabled: false,
    href: "/",
  },
  {
    text: "Справочники: Справочник сроков хранения",
    disabled: true,
    href: "breadcrumbs_link_1",
  },
];
